import { ISelectOption } from "Interfaces/interface.mockupGenerator";

// Services
export const PlatformServices = {
  MOCKUP: "mokcup",
  CATALOG: "catalog",
};

// MOCKUP
export const BlendModeEnum = {
  NORMAL: "normal",
  OVERLAY: "overlay",
  SCREEN: "screen",
  MULTIPLY: "multiply",
};

export const OutputFormatEnum = {
  PNG: "png",
  JPG: "jpg",
  JPEG: "jpeg",
};

export const blendModeOptions: ISelectOption[] = [
  { value: BlendModeEnum.NORMAL, label: "Normal" },
  { value: BlendModeEnum.OVERLAY, label: "Overlay" },
  { value: BlendModeEnum.SCREEN, label: "Screen" },
  { value: BlendModeEnum.MULTIPLY, label: "Multiply" },
];

export const outputFormatOptions: ISelectOption[] = [
  { value: OutputFormatEnum.PNG, label: "PNG" },
  { value: OutputFormatEnum.JPG, label: "JPG" },
  { value: OutputFormatEnum.JPEG, label: "JPEG" },
];

export const PrintingTypeEnum = {
  SCREEN_PRINTING: "screen_printing",
  EMBROIDERY: "embroidery",
  ENGRAVING: "engraving",
  UV_PRINTING: "uv_printing",
  HEAT_TRANSFER: "heat_transfer",
  DIGITAL_PRINTING: "digital_printing",
  FOIL_STAMPING: "foil_stamping",
  LASER_CUTTING: "laser_cutting",
};

export const printingTypeOptions: ISelectOption[] = [
  { value: PrintingTypeEnum.SCREEN_PRINTING, label: "Screen Printing" },
  { value: PrintingTypeEnum.EMBROIDERY, label: "Embroidery" },
  { value: PrintingTypeEnum.ENGRAVING, label: "Engraving" },
  { value: PrintingTypeEnum.UV_PRINTING, label: "UV Printing" },
  { value: PrintingTypeEnum.HEAT_TRANSFER, label: "Heat Transfer" },
  { value: PrintingTypeEnum.DIGITAL_PRINTING, label: "Digital Printing" },
  { value: PrintingTypeEnum.FOIL_STAMPING, label: "Foil Stamping" },
  { value: PrintingTypeEnum.LASER_CUTTING, label: "Laser Cutting" },
];

export const mockupGenerationMessages = [
  "Preparing logo layout...",
  "Applying selected logo...",
  "Optimizing image resolution...",
  "Rendering high-resolution mockup...",
  "Finalizing mockup details...",
];

// CATALOG
export const catalogGenerationMessages = [
  "Initializing your catalog design...",
  "Incorporating selected products...",
  "Structuring the grid layout...",
  "Applying your custom theme...",
  "Finalizing your masterpiece...",
];
